<template>
  <v-dialog persistent content-class="bg-white p-4 font-lato" v-model="isConfirmShow.isShow" @keydown.esc="closeDialog()" max-width="616">
    <h4 style="font-size: 24px; color: #3F3F3F;" v-html="isConfirmShow.title"></h4>
    <p class="m-0 my-6" style="font-size: 14px; color: #3F3F3F;">
      {{ isConfirmShow.description }}
    </p>
    <slot></slot>
    <div v-if="isConfirmShow.type === 'changes'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
      <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
      <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-danger" @click="resetChanges" style="border: none;">Discard</button>
        <button class="btn btn-primary ml-2" @click="saveReport" :disabled="selectedColumns.length === 0">Keep Changes</button>
      </div>
    </div>
    <div v-else-if="isConfirmShow.type === 'update'" class="d-flex justify-content-end align-items-center" style="gap: 8px;">
      <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
      <button class="btn btn-primary" @click="saveReport" :disabled="selectedColumns.length === 0">Update</button>
    </div>
    <div v-else-if="isConfirmShow.type === 'preview'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
      <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
      <button class="btn btn-primary" @click="updateToPreview" :disabled="selectedColumns.length === 0">Update and Preview</button>
    </div>
    <div v-else-if="isConfirmShow.type === 'run'" class="d-flex justify-content-between align-items-center" style="gap: 8px;">
      <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
      <button class="btn btn-primary" @click="updateToRun" :disabled="selectedColumns.length === 0">Update and Run</button>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CButton from '../c-button.vue'


export default {
  components: {
    CButton,
  },
  props: {
    flag: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      reportTemplate: "reportTemplates/reportTemplate",
      isConfirmShow: "reportTemplates/isConfirmShow",
      selectedColumns: "reportTemplates/selectedColumns",
      originalColumns: "reportTemplates/originalColumns",
      fieldPagination: 'reportTemplates/fieldPagination',
    }),
    filters() {
      return this.reportTemplate?.filter_options || [];
    },
  },
  data() {
    return {

    }
  },
  async created() {
    this.timeoutId = setTimeout(() => {
    
    }, 500);
  },
  methods: {
    ...mapActions({
      saveReportTemplate: "reportTemplates/saveReportTemplate",
    }),
    closeDialog() {
      this.$store.commit('reportTemplates/setConfirmShow', { isShow: false });
    },
    handleCloseOutside(e) {
      const overlay = document.getElementsByClassName('v-overlay__scrim');
      if (overlay[0] && overlay[0].contains(e.target)) {
        this.closeDialog();
      }
    },
    async saveReport() {
      await this.saveReportTemplate();
      this.closeDialog();

      const redirect = this.isConfirmShow?.redirect;
      if (redirect) {
        window.location.href = redirect;
      }
    },
    resetChanges() {
      const perPage = this.fieldPagination.per_page;
      const totalCount = this.originalColumns.length;
      const totalPages = Math.ceil(totalCount / perPage);
      
      let currentPage = this.fieldPagination.current_page;
      
      if (totalPages > 0 && currentPage === 0) {
        currentPage = 1;
      } else if (currentPage > totalPages) {
        currentPage = totalPages;
      }
      
      this.$store.commit('reportTemplates/setSelectedColumns', this.originalColumns);
      this.$store.commit('reportTemplates/setAppliedFilters', this.reportTemplate.filter || {});
      this.$store.commit('reportTemplates/setFieldPagination', {
        current_page: currentPage,
        per_page: perPage,
        total_count: totalCount,
        total_pages: totalPages,
        count: perPage,
      });
      this.$store.commit('reportTemplates/setUnsavedChanges', this.hasUnsavedChanges);
      this.closeDialog();
    },
    async updateToPreview() {
      await this.saveReportTemplate();
      await this.closeDialog();
      window.location.href = `/dashboard/report_list/${this.reportTemplate?.id}`;
    },
    async updateToRun() {
      await this.saveReportTemplate();
      await this.$store.dispatch('reportTemplates/exportReport', this.reportTemplate?.id);
      await this.closeDialog();
    }
  },
  mounted() {
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
     
  },
}
</script>

<style lang="scss" scoped></style>